import type { FC } from "react"
import React from "react"

import { useTranslation } from "react-i18next"
import { useRecoilValue } from "recoil"
import styled from "styled-components"

import { beforeSolarPlanHasContractedRatesState } from "~/components/UtilityDropdowns"
import type { Interlingual } from "~/i18n/types"

import { designLocalState } from "../../state/designs/design-state"
import { useProposalContext } from "../../state/proposal/proposal-context"

const DisclaimerText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: left;
  margin-top: 50px;
  gap: 10px;
  p {
    text-align: left;
    font-size: var(--step--1);
    color: #bc2626;
  }
`

export const Disclaimers: FC = () => {
  const { local } = useProposalContext()
  const { postSolarUtilityRate } = local
  const design = useRecoilValue(designLocalState)

  const showPostSolarDisclaimer = Boolean(
    postSolarUtilityRate?.hasTimeOfUseRates === true &&
      (design?.energyBackupId != null ||
        design?.inverter?.inverterData?.isBattery),
  )
  const hasContractedRates = useRecoilValue(
    beforeSolarPlanHasContractedRatesState,
  )

  const disclaimers = React.useMemo<Interlingual[]>(() => {
    const all: Interlingual[] = [
      `monthlyBillDisclaimer`,
      `postSolarUtilityCalculationDisclaimer`,
      `deregulatedRatesNotice`,
    ] as const

    const hidden: Interlingual[] = []
    if (!hasContractedRates) {
      hidden.push(`deregulatedRatesNotice`)
    }
    if (!showPostSolarDisclaimer) {
      hidden.push(`postSolarUtilityCalculationDisclaimer`)
    }

    return all.filter((disc) => !hidden.includes(disc))
  }, [showPostSolarDisclaimer, hasContractedRates])

  const { t } = useTranslation()

  return (
    <DisclaimerText>
      {disclaimers.map((disc: Interlingual) => (
        <p key={disc}>{t(disc) as string}</p>
      ))}
    </DisclaimerText>
  )
}
